export default {"src":"__ASTRO_ASSET_IMAGE__CmxRHN$4__","width":800,"height":350,"format":"jpg"}